import React from 'react';
import styled from 'styled-components';
import { ToggleButton } from '../../../../StyledComponents/UserFormStyledComponents';

const ToggleContainer = styled.div`
    display: flex;
    height: 44px;
    margin: 0;
`;

const StockChartToggle = ({ chartType, setChartType, onToggle }) => {
    const handleToggle = (type) => {
        setChartType(type);
        if (onToggle) {
            onToggle();
        }
    };

    return (
        <ToggleContainer>
            <ToggleButton isActive={chartType === 'D'} onClick={() => handleToggle('D')}>D</ToggleButton>
            <ToggleButton isActive={chartType === '10m'} onClick={() => handleToggle('10m')}>10m</ToggleButton>
        </ToggleContainer>
    );
}

export default StockChartToggle;